// Merchant-controlled descriptions only need basic text formatting. Excluding
// links and externally loaded elements also prevents descriptions from being
// used for script execution or tracking.
export const ALLOWED_DESCRIPTION_TAGS = ['b', 'i', 'strong', 'em', 'u', 's', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];